import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormFieldContext } from '../../form-field/form-field.context';
import { RadioButtonGroupProvider } from './radio-button-group.context';

/**
 * @typedef Props
 * @prop {React.ReactChildren} children
 * @prop {string} [className]
 * @prop {boolean} [disabled]
 * @prop {string} [name]
 * @prop {boolean} [required]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifRadioButtonGroup = (props) => {
  const { children, className = '', disabled = false, name = null, required = false, ...other } = props;
  const formFieldContext = useContext(FormFieldContext);

  const classes = classNames({
    'motif-radio-button-group': true,

    /**
     * .motif-radio-button-group-invalid is applied to use as wrap for .motif-radio-button-custom, see src/components/forms/radio-button/_radio-button.scss
     */
    'motif-radio-button-group-invalid': formFieldContext.invalid,
    [className]: true
  });
  const contextSetting = {
    isGroup: true,
    groupName: name,
    groupRequired: required,
    groupDisabled: disabled
  };

  return (
    <RadioButtonGroupProvider value={contextSetting}>
      <div {...other} className={classes} data-motif-radio-button-group>
        {children}
      </div>
    </RadioButtonGroupProvider>
  );
};

MotifRadioButtonGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  required: PropTypes.bool
};

export { MotifRadioButtonGroup };
